import { render, staticRenderFns } from "./PartnerRequestsEdit.vue?vue&type=template&id=4aa7cf9a&"
import script from "./PartnerRequestsEdit.vue?vue&type=script&lang=js&"
export * from "./PartnerRequestsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports